export const BASE_MAP_CONTROLS = ['zoomControl', 'typeSelector'];
export const MAP_SEARCH_UNAVAILABLE_MESSAGE = 'Поиск по карте недоступен на текущем контуре';

export const probeMapSearch = (apiKey, suggestApiKey, ymaps) => {
  if (!apiKey || !suggestApiKey || !ymaps || typeof ymaps.suggest !== 'function') {
    return Promise.resolve(false);
  }

  return new Promise(resolve => {
    try {
      const request = ymaps.suggest('Москва', { results: 1 });
      if (!request || typeof request.then !== 'function') {
        resolve(false);
        return;
      }
      request.then(items => resolve(Array.isArray(items) && items.length > 0), () => resolve(false));
    } catch (e) {
      resolve(false);
    }
  });
};
